import { render, staticRenderFns } from "./prescriptionSelect.vue?vue&type=template&id=34502819"
import script from "./prescriptionSelect.vue?vue&type=script&lang=js"
export * from "./prescriptionSelect.vue?vue&type=script&lang=js"
import style0 from "./prescriptionSelect.vue?vue&type=style&index=0&id=34502819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_cache-loader@4.1.0_webpack@4.47.0__css-load_96f0868f9f114531bdcfa48c322cb453/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports